import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Segment, SEGMENT_PRIVATE } from '../../../stores/SegmentStore';

interface PartnerInternetDescriptionButtonProps {
  segment?: Segment;
}

const PartnerInternetDescriptionButton = (props: PartnerInternetDescriptionButtonProps): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;
  const { segment } = props;
  if (segment === 'BUSINESS') {
    return null;
  }

  return (
    <div className="text text-center">
      <AnalyticsTrigger trigger={{ id: segment === SEGMENT_PRIVATE ? 'Link - Partnerinternet - Vaatan lähemalt' : 'Link', callback: 'onClick' }}>
        <Button
          className="text__margin-double"
          text={translate('internetAndTvCalculator.elektrileviInternet.buttonText')}
          iconRight="#arrow-right"
          link={true}
          url={translate('internetAndTvCalculator.elektrileviInternet.buttonUrl')}
          target="_blank"
        />
      </AnalyticsTrigger>
    </div>
  );
};

export default observer(PartnerInternetDescriptionButton);
